<template>
  <DiscordTechDesign variant="dream" />
</template>

<script>
import DiscordTechDesign from './DiscordTechDesign.vue';

export default {
  name: 'DiscordTech4',
  components: { DiscordTechDesign },
};
</script>
